import { useEffect, useRef, type ReactNode } from 'react';
import { Modal } from '../ui/kit/components/overlays';
import { Button } from '../ui/kit/components/primitives';
import '../ui/styles/components.css';

interface ConfirmDialogProps {
  title: string;
  body: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  tone?: 'danger' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({ title, body, confirmLabel, cancelLabel = 'Cancel', tone = 'danger', onConfirm, onCancel }: ConfirmDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  useEffect(() => { cancelRef.current?.focus(); }, []);
  return <div className="bs-theme"><Modal open onOpenChange={onCancel} title={title} footer={<><Button ref={cancelRef} onClick={onCancel}>{cancelLabel}</Button><Button variant={tone === 'danger' ? 'danger' : 'primary'} onClick={onConfirm}>{confirmLabel}</Button></>}>
    <div>{body}</div>
  </Modal></div>;
}